import axios from 'axios';

export const initialState = {
  pages: [],
  editPage: {
    content: '<div class="row col-12 justify-content-center align-items-center" style="height: 300px">Bitte wählen Sie eine Seite aus</div>'
  }
};

export const mutations = {
  SET_PAGES(state, newValue) {
    state.pages = newValue;
  },
  SET_EDIT_PAGE(state, newValue) {
    state.editPage = newValue;
  },
  RESET(state) {
    Object.keys(state).forEach((attr) => { state[attr] = initialState[attr]; });
  },
};

export const actions = {

  async getAllPages({ commit }) {
    const { data } = await axios.get('/pages');
    commit('SET_PAGES', data.data);
  },

  async updateEditPage({ state }) {
    return axios.put(`/pages/${state.editPage.ID}`, state.editPage);
  }

};


export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};
